import { Component } from '@angular/core';

@Component({
  selector: 'app-agb',
  templateUrl: './agb.component.html',
  styleUrl: './agb.component.scss',
  standalone: false,
})
export class AgbComponent {
  public copyToClipboard(text: string): void {
    navigator.clipboard
      .writeText(text)
      .then(() => {})
      .catch(err => {
        console.error('Failed to copy text to clipboard', err);
      });
  }
}
